export const waysMDFe = {
    // --- ROTAS DO ACRE (AC) ---
    "AC-AL": ["RO", "MT", "GO", "BA", "SE"],
    "AC-AP": ["RO", "AM", "PA"],
    "AC-AM": [],
    "AC-BA": ["RO", "MT", "GO"],
    "AC-CE": ["RO", "MT", "GO", "BA", "PI"],
    "AC-DF": ["RO", "MT", "GO"],
    "AC-ES": ["RO", "MT", "GO", "MG"],
    "AC-GO": ["RO", "MT"],
    "AC-MA": ["RO", "MT", "TO"],
    "AC-MG": ["RO", "MT", "GO"],
    "AC-MS": ["RO", "MT"],
    "AC-MT": ["RO"],
    "AC-PA": ["RO", "MT"],
    "AC-PB": ["RO", "MT", "GO", "BA", "PE"],
    "AC-PE": ["RO", "MT", "GO", "BA"],
    "AC-PI": ["RO", "MT", "TO"],
    "AC-PR": ["RO", "MT", "MS"],
    "AC-RJ": ["RO", "MT", "GO", "MG"],
    "AC-RN": ["RO", "MT", "GO", "BA", "CE"],
    "AC-RO": [],
    "AC-RR": ["AM"],
    "AC-RS": ["RO", "MT", "MS", "PR"],
    "AC-SC": ["RO", "MT", "MS", "PR"],
    "AC-SE": ["RO", "MT", "GO", "BA"],
    "AC-SP": ["RO", "MT", "GO", "MG"],
    "AC-TO": ["RO", "MT"],

    // --- ROTAS DE ALAGOAS (AL) ---
    "AL-AC": ["SE", "BA", "GO", "MT", "RO"],
    "AL-AP": ["SE", "BA", "TO", "PA"],
    "AL-AM": ["SE", "BA", "GO", "MT"],
    "AL-BA": ["SE"],
    "AL-CE": ["PE", "PB"],
    "AL-DF": ["SE", "BA", "GO"],
    "AL-ES": ["SE", "BA", "MG"],
    "AL-GO": ["SE", "BA"],
    "AL-MA": ["SE", "BA", "PI"],
    "AL-MG": ["SE", "BA"],
    "AL-MS": ["SE", "BA", "GO"],
    "AL-MT": ["SE", "BA", "GO"],
    "AL-PA": ["PE", "PB", "CE", "PI", "MA"],
    "AL-PB": ["PE"],
    "AL-PE": [],
    "AL-PI": ["PE", "CE"],
    "AL-PR": ["SE", "BA", "MG", "SP"],
    "AL-RJ": ["SE", "BA", "MG"],
    "AL-RN": ["PE", "PB"],
    "AL-RO": ["SE", "BA", "GO", "MT"],
    "AL-RR": ["SE", "BA", "GO", "MT", "AM"],
    "AL-RS": ["SE", "BA", "MG", "SP", "PR"],
    "AL-SC": ["SE", "BA", "MG", "SP"],
    "AL-SE": [],
    "AL-SP": ["SE", "BA", "MG"],
    "AL-TO": ["SE", "BA", "GO"],

    // --- ROTAS DO AMAPÁ (AP) ---
    "AP-AC": ["PA", "MT", "RO"],
    "AP-AL": ["PA", "MA", "PI", "CE", "PB", "PE"],
    "AP-AM": ["PA"],
    "AP-BA": ["PA", "TO", "GO"],
    "AP-CE": ["PA", "MA", "PI"],
    "AP-DF": ["PA", "TO", "GO"],
    "AP-ES": ["PA", "TO", "GO", "MG"],
    "AP-GO": ["PA", "TO"],
    "AP-MA": ["PA"],
    "AP-MG": ["PA", "TO", "GO"],
    "AP-MS": ["PA", "TO", "GO"],
    "AP-MT": ["PA", "TO"],
    "AP-PA": [],
    "AP-PB": ["PA", "MA", "PI", "CE"],
    "AP-PE": ["PA", "MA", "PI", "CE"],
    "AP-PI": ["PA", "MA"],
    "AP-PR": ["PA", "TO", "GO", "MS"],
    "AP-RJ": ["PA", "TO", "GO", "MG"],
    "AP-RN": ["PA", "MA", "PI", "CE"],
    "AP-RO": ["PA", "MT"],
    "AP-RR": ["PA", "AM"],
    "AP-RS": ["PA", "TO", "GO", "MS", "PR"],
    "AP-SC": ["PA", "TO", "GO", "MS", "PR"],
    "AP-SE": ["PA", "TO", "BA"],
    "AP-SP": ["PA", "TO", "GO", "MG"],
    "AP-TO": ["PA"],

    // --- ROTAS DO AMAZONAS (AM) ---
    "AM-AC": ["RO"],
    "AM-AL": ["PA", "TO", "BA", "SE"],
    "AM-AP": ["PA"],
    "AM-BA": ["MT", "GO"],
    "AM-CE": ["PA", "MA", "PI"],
    "AM-DF": ["MT", "GO"],
    "AM-ES": ["MT", "GO", "MG"],
    "AM-GO": ["MT"],
    "AM-MA": ["PA"],
    "AM-MG": ["MT", "GO"],
    "AM-MS": ["MT"],
    "AM-MT": ["RO"],
    "AM-PA": ["MT"],
    "AM-PB": ["PA", "MA", "PI", "CE"],
    "AM-PE": ["PA", "MA", "PI", "CE"],
    "AM-PI": ["PA", "MA"],
    "AM-PR": ["MT", "MS"],
    "AM-RJ": ["MT", "GO", "MG"],
    "AM-RN": ["PA", "MA", "PI", "CE"],
    "AM-RO": [],
    "AM-RR": [],
    "AM-RS": ["MT", "MS", "PR"],
    "AM-SC": ["MT", "MS", "PR"],
    "AM-SE": ["MT", "GO", "BA"],
    "AM-SP": ["MT", "GO", "MG"],
    "AM-TO": ["PA"],

    // --- ROTAS DA BAHIA (BA) ---
    "BA-AC": ["GO", "MT", "RO"],
    "BA-AL": ["SE"],
    "BA-AP": ["TO", "PA"],
    "BA-AM": ["GO", "MT"],
    "BA-CE": ["PI"],
    "BA-DF": ["GO"],
    "BA-ES": [],
    "BA-GO": [],
    "BA-MA": ["TO"],
    "BA-MG": ["ES"],
    "BA-MS": ["GO"],
    "BA-MT": ["GO"],
    "BA-PA": ["TO"],
    "BA-PB": ["PE"],
    "BA-PE": [],
    "BA-PI": [],
    "BA-PR": ["MG", "SP"],
    "BA-RJ": ["ES", "MG"],
    "BA-RN": ["PE", "PB"],
    "BA-RO": ["GO", "MT"],
    "BA-RR": ["TO", "PA", "AM"],
    "BA-RS": ["MG", "SP", "PR"],
    "BA-SC": ["MG", "SP", "PR"],
    "BA-SE": [],
    "BA-SP": ["MG"],
    "BA-TO": ["GO"],

    // --- ROTAS DO CEARÁ (CE) ---
    "CE-AC": ["PI", "MA", "TO", "MT", "RO"],
    "CE-AL": ["PB", "PE"],
    "CE-AP": ["PI", "MA", "PA"],
    "CE-AM": ["PI", "MA", "PA"],
    "CE-BA": ["PI"],
    "CE-DF": ["PI", "TO", "GO"],
    "CE-ES": ["PI", "BA", "MG"],
    "CE-GO": ["PI", "TO"],
    "CE-MA": ["PI"],
    "CE-MG": ["PI", "BA"],
    "CE-MS": ["PI", "TO", "GO"],
    "CE-MT": ["PI", "TO"],
    "CE-PA": ["PI", "MA"],
    "CE-PB": ["RN"],
    "CE-PE": ["PB"],
    "CE-PI": [],
    "CE-PR": ["PI", "BA", "MG", "SP"],
    "CE-RJ": ["PI", "BA", "MG"],
    "CE-RN": [],
    "CE-RO": ["PI", "MA", "TO", "MT"],
    "CE-RR": ["PI", "MA", "PA", "AM"],
    "CE-RS": ["PI", "BA", "MG", "SP", "PR"],
    "CE-SC": ["PI", "BA", "MG", "SP", "PR"],
    "CE-SE": ["PI", "BA"],
    "CE-SP": ["PI", "BA", "MG"],
    "CE-TO": ["PI", "MA"],

    // --- ROTAS DO DISTRITO FEDERAL (DF) ---
    "DF-AC": ["GO", "MT", "RO"],
    "DF-AL": ["GO", "BA", "SE"],
    "DF-AP": ["GO", "TO", "PA"],
    "DF-AM": ["GO", "MT"],
    "DF-BA": ["GO"],
    "DF-CE": ["GO", "TO", "PI"],
    "DF-ES": ["MG"],
    "DF-GO": [],
    "DF-MA": ["GO", "TO"],
    "DF-MG": ["GO"],
    "DF-MS": ["GO"],
    "DF-MT": ["GO"],
    "DF-PA": ["GO", "TO"],
    "DF-PB": ["GO", "BA", "PE"],
    "DF-PE": ["GO", "BA"],
    "DF-PI": ["GO", "TO"],
    "DF-PR": ["GO", "MS"],
    "DF-RJ": ["MG"],
    "DF-RN": ["GO", "BA", "CE"],
    "DF-RO": ["GO", "MT"],
    "DF-RR": ["GO", "MT", "AM"],
    "DF-RS": ["GO", "MS", "PR"],
    "DF-SC": ["GO", "MS", "PR"],
    "DF-SE": ["GO", "BA"],
    "DF-SP": ["MG"],
    "DF-TO": ["GO"],

    // --- ROTAS DO ESPÍRITO SANTO (ES) ---
    "ES-AC": ["MG", "GO", "MT", "RO"],
    "ES-AL": ["MG", "BA", "SE"],
    "ES-AP": ["MG", "GO", "TO", "PA"],
    "ES-AM": ["MG", "GO", "MT"],
    "ES-BA": [],
    "ES-CE": ["BA", "PI"],
    "ES-DF": ["MG", "GO"],
    "ES-GO": ["MG"],
    "ES-MA": ["MG", "BA", "TO"],
    "ES-MG": [],
    "ES-MS": ["MG", "GO"],
    "ES-MT": ["MG", "GO"],
    "ES-PA": ["MG", "GO", "TO"],
    "ES-PB": ["BA", "PE"],
    "ES-PE": ["BA"],
    "ES-PI": ["BA"],
    "ES-PR": ["MG", "SP"],
    "ES-RJ": [],
    "ES-RN": ["BA", "CE"],
    "ES-RO": ["MG", "GO", "MT"],
    "ES-RR": ["MG", "GO", "MT", "AM"],
    "ES-RS": ["MG", "SP", "PR"],
    "ES-SC": ["MG", "SP", "PR"],
    "ES-SE": ["BA"],
    "ES-SP": ["MG"],
    "ES-TO": ["MG", "GO"],

    // --- ROTAS DE GOIÁS (GO) ---
    "GO-AC": ["MT", "RO"],
    "GO-AL": ["BA", "SE"],
    "GO-AP": ["TO", "PA"],
    "GO-AM": ["MT"],
    "GO-BA": [],
    "GO-CE": ["TO", "PI"],
    "GO-DF": [],
    "GO-ES": ["MG"],
    "GO-MA": ["TO"],
    "GO-MG": [],
    "GO-MS": [],
    "GO-MT": [],
    "GO-PA": ["TO"],
    "GO-PB": ["BA", "PE"],
    "GO-PE": ["BA"],
    "GO-PI": ["TO"],
    "GO-PR": ["MS"],
    "GO-RJ": ["MG"],
    "GO-RN": ["BA", "CE"],
    "GO-RO": ["MT"],
    "GO-RR": ["MT", "AM"],
    "GO-RS": ["MS", "PR"],
    "GO-SC": ["MS", "PR"],
    "GO-SE": ["BA"],
    "GO-SP": ["MG"],
    "GO-TO": [],

    // --- ROTAS DO MARANHÃO (MA) ---
    "MA-AC": ["TO", "MT", "RO"],
    "MA-AL": ["PI", "CE", "PB", "PE"],
    "MA-AP": ["PA"],
    "MA-AM": ["PA"],
    "MA-BA": ["TO"],
    "MA-CE": ["PI"],
    "MA-DF": ["TO", "GO"],
    "MA-ES": ["TO", "GO", "MG"],
    "MA-GO": ["TO"],
    "MA-MG": ["TO", "GO"],
    "MA-MS": ["TO", "GO"],
    "MA-MT": ["TO"],
    "MA-PA": [],
    "MA-PB": ["PI", "CE"],
    "MA-PE": ["PI", "CE"],
    "MA-PI": [],
    "MA-PR": ["TO", "GO", "MS"],
    "MA-RJ": ["TO", "GO", "MG"],
    "MA-RN": ["PI", "CE"],
    "MA-RO": ["TO", "MT"],
    "MA-RR": ["PA", "AM"],
    "MA-RS": ["TO", "GO", "MS", "PR"],
    "MA-SC": ["TO", "GO", "MS", "PR"],
    "MA-SE": ["TO", "BA"],
    "MA-SP": ["TO", "GO", "MG"],
    "MA-TO": [],

    // --- ROTAS DE MINAS GERAIS (MG) ---
    "MG-AC": ["GO", "MT", "RO"],
    "MG-AL": ["BA", "SE"],
    "MG-AP": ["GO", "TO", "PA"],
    "MG-AM": ["GO", "MT"],
    "MG-BA": ["ES"],
    "MG-CE": ["BA", "PI"],
    "MG-DF": ["GO"],
    "MG-ES": [],
    "MG-GO": [],
    "MG-MA": ["GO", "TO"],
    "MG-MS": ["GO"],
    "MG-MT": ["GO"],
    "MG-PA": ["GO", "TO"],
    "MG-PB": ["BA", "PE"],
    "MG-PE": ["BA"],
    "MG-PI": ["BA"],
    "MG-PR": ["SP"],
    "MG-RJ": [],
    "MG-RN": ["BA", "CE"],
    "MG-RO": ["GO", "MT"],
    "MG-RR": ["GO", "MT", "AM"],
    "MG-RS": ["SP", "PR"],
    "MG-SC": ["SP", "PR"],
    "MG-SE": ["BA"],
    "MG-SP": [],
    "MG-TO": ["GO"],

    // --- ROTAS DE MATO GROSSO DO SUL (MS) ---
    "MS-AC": ["MT", "RO"],
    "MS-AL": ["GO", "BA", "SE"],
    "MS-AP": ["GO", "TO", "PA"],
    "MS-AM": ["MT"],
    "MS-BA": ["GO"],
    "MS-CE": ["GO", "TO", "PI"],
    "MS-DF": ["GO"],
    "MS-ES": ["GO", "MG"],
    "MS-GO": [],
    "MS-MA": ["GO", "TO"],
    "MS-MG": ["GO"],
    "MS-MT": [],
    "MS-PA": ["MT", "TO"],
    "MS-PB": ["GO", "BA", "PE"],
    "MS-PE": ["GO", "BA"],
    "MS-PI": ["GO", "TO"],
    "MS-PR": [],
    "MS-RJ": ["GO", "MG"],
    "MS-RN": ["GO", "BA", "CE"],
    "MS-RO": ["MT"],
    "MS-RR": ["MT", "AM"],
    "MS-RS": ["PR"],
    "MS-SC": ["PR"],
    "MS-SE": ["GO", "BA"],
    "MS-SP": ["PR"],
    "MS-TO": ["MT"],

    // --- ROTAS DE MATO GROSSO (MT) ---
    "MT-AC": ["RO"],
    "MT-AL": ["GO", "BA", "SE"],
    "MT-AP": ["PA"],
    "MT-AM": ["RO"],
    "MT-BA": ["GO"],
    "MT-CE": ["GO", "TO", "PI"],
    "MT-DF": ["GO"],
    "MT-ES": ["GO", "MG"],
    "MT-GO": [],
    "MT-MA": ["GO", "TO"],
    "MT-MG": ["GO"],
    "MT-MS": [],
    "MT-PA": [],
    "MT-PB": ["GO", "BA", "PE"],
    "MT-PE": ["GO", "BA"],
    "MT-PI": ["GO", "TO"],
    "MT-PR": ["MS"],
    "MT-RJ": ["GO", "MG"],
    "MT-RN": ["GO", "BA", "CE"],
    "MT-RO": [],
    "MT-RR": ["AM"],
    "MT-RS": ["MS", "PR"],
    "MT-SC": ["MS", "PR"],
    "MT-SE": ["GO", "BA"],
    "MT-SP": ["GO", "MG"],
    "MT-TO": [],

    // --- ROTAS DO PARÁ (PA) ---
    "PA-AC": ["MT", "RO"],
    "PA-AL": ["TO", "BA", "SE"],
    "PA-AP": [],
    "PA-AM": [],
    "PA-BA": ["TO"],
    "PA-CE": ["MA", "PI"],
    "PA-DF": ["TO", "GO"],
    "PA-ES": ["TO", "GO", "MG"],
    "PA-GO": ["TO"],
    "PA-MA": [],
    "PA-MG": ["TO", "GO"],
    "PA-MS": ["TO", "GO"],
    "PA-MT": [],
    "PA-PB": ["MA", "PI", "CE"],
    "PA-PE": ["MA", "PI", "CE"],
    "PA-PI": ["MA"],
    "PA-PR": ["TO", "GO", "MS"],
    "PA-RJ": ["TO", "GO", "MG"],
    "PA-RN": ["MA", "PI", "CE"],
    "PA-RO": ["MT"],
    "PA-RR": ["AM"],
    "PA-RS": ["TO", "GO", "MS", "PR"],
    "PA-SC": ["TO", "GO", "MS", "PR"],
    "PA-SE": ["TO", "BA"],
    "PA-SP": ["TO", "GO", "MG"],
    "PA-TO": [],

    // --- ROTAS DA PARAÍBA (PB) ---
    "PB-AC": ["PE", "BA", "GO", "MT", "RO"],
    "PB-AL": ["PE"],
    "PB-AP": ["CE", "PI", "MA", "PA"],
    "PB-AM": ["CE", "PI", "MA", "PA"],
    "PB-BA": ["PE"],
    "PB-CE": [],
    "PB-DF": ["PE", "BA", "GO"],
    "PB-ES": ["PE", "BA", "MG"],
    "PB-GO": ["PE", "BA"],
    "PB-MA": ["CE", "PI"],
    "PB-MG": ["PE", "BA"],
    "PB-MS": ["PE", "BA", "GO"],
    "PB-MT": ["PE", "BA", "GO"],
    "PB-PA": ["CE", "PI", "MA"],
    "PB-PE": [],
    "PB-PI": ["CE"],
    "PB-PR": ["PE", "BA", "MG", "SP"],
    "PB-RJ": ["PE", "BA", "MG"],
    "PB-RN": [],
    "PB-RO": ["PE", "BA", "GO", "MT"],
    "PB-RR": ["PE", "BA", "GO", "MT", "AM"],
    "PB-RS": ["PE", "BA", "MG", "SP", "PR"],
    "PB-SC": ["PE", "BA", "MG", "SP"],
    "PB-SE": ["PE", "BA"],
    "PB-SP": ["PE", "BA", "MG"],
    "PB-TO": ["PE", "BA", "GO"],

    // --- ROTAS DE PERNAMBUCO (PE) ---
    "PE-AC": ["BA", "GO", "MT", "RO"],
    "PE-AL": [],
    "PE-AP": ["PB", "CE", "PI", "MA", "PA"],
    "PE-AM": ["PB", "CE", "PI", "MA", "PA"],
    "PE-BA": ["AL"],
    "PE-CE": ["PB"],
    "PE-DF": ["BA", "GO"],
    "PE-ES": ["BA", "MG"],
    "PE-GO": ["BA"],
    "PE-MA": ["PI", "CE"],
    "PE-MG": ["BA"],
    "PE-MS": ["BA", "GO"],
    "PE-MT": ["BA", "GO"],
    "PE-PA": ["PB", "CE", "PI", "MA"],
    "PE-PB": [],
    "PE-PI": ["PB", "CE"],
    "PE-PR": ["BA", "MG", "SP"],
    "PE-RJ": ["BA", "MG"],
    "PE-RN": ["PB"],
    "PE-RO": ["BA", "GO", "MT"],
    "PE-RR": ["PB", "CE", "PI", "MA", "PA"],
    "PE-RS": ["BA", "MG", "SP", "PR"],
    "PE-SC": ["BA", "MG", "SP", "PR"],
    "PE-SE": ["AL"],
    "PE-SP": ["BA", "MG"],
    "PE-TO": ["BA", "GO"],

    // --- ROTAS DO PIAUÍ (PI) ---
    "PI-AC": ["MA", "TO", "MT", "RO"],
    "PI-AL": ["CE", "PE"],
    "PI-AP": ["MA", "PA"],
    "PI-AM": ["MA", "PA"],
    "PI-BA": ["MA"],
    "PI-CE": [],
    "PI-DF": ["TO", "GO"],
    "PI-ES": ["BA", "MG"],
    "PI-GO": ["TO"],
    "PI-MA": [],
    "PI-MG": ["BA"],
    "PI-MS": ["GO"],
    "PI-MT": ["TO"],
    "PI-PA": ["MA"],
    "PI-PB": ["CE"],
    "PI-PE": ["CE", "PB"],
    "PI-PR": ["BA", "MG", "SP"],
    "PI-RJ": ["BA", "MG"],
    "PI-RN": ["CE"],
    "PI-RO": ["MA", "TO", "MT"],
    "PI-RR": ["MA", "PA", "AM"],
    "PI-RS": ["BA", "MG", "SP", "PR"],
    "PI-SC": ["BA", "MG", "SP", "PR"],
    "PI-SE": ["BA"],
    "PI-SP": ["BA", "MG"],
    "PI-TO": ["MA"],

    // --- ROTAS DO PARANÁ (PR) ---
    "PR-AC": ["MS", "MT", "RO"],
    "PR-AL": ["SP", "MG", "BA", "SE"],
    "PR-AP": ["SP", "MG", "GO", "TO", "PA"],
    "PR-AM": ["MS", "MT"],
    "PR-BA": ["SP", "MG"],
    "PR-CE": ["SP", "MG", "BA", "PI"],
    "PR-DF": ["MS", "GO"],
    "PR-ES": ["SP", "MG"],
    "PR-GO": ["MS"],
    "PR-MA": ["MS", "GO", "TO"],
    "PR-MG": ["SP"],
    "PR-MS": [],
    "PR-MT": ["MS"],
    "PR-PA": ["MS", "MT", "TO"],
    "PR-PB": ["SP", "MG", "BA", "PE"],
    "PR-PE": ["SP", "MG", "BA"],
    "PR-PI": ["SP", "MG", "BA"],
    "PR-RJ": ["SP"],
    "PR-RN": ["SP", "MG", "BA", "CE"],
    "PR-RO": ["MS", "MT"],
    "PR-RR": ["MS", "MT", "AM"],
    "PR-RS": [],
    "PR-SC": [],
    "PR-SE": ["SP", "MG", "BA"],
    "PR-SP": [],
    "PR-TO": ["MS", "MT"],

    // --- ROTAS DO RIO DE JANEIRO (RJ) ---
    "RJ-AC": ["MG", "GO", "MT", "RO"],
    "RJ-AL": ["MG", "BA", "SE"],
    "RJ-AP": ["MG", "GO", "TO", "PA"],
    "RJ-AM": ["MG", "GO", "MT"],
    "RJ-BA": ["MG"],
    "RJ-CE": ["MG", "BA", "PI"],
    "RJ-DF": ["MG", "GO"],
    "RJ-ES": [],
    "RJ-GO": ["MG"],
    "RJ-MA": ["MG", "GO", "TO"],
    "RJ-MG": [],
    "RJ-MS": ["SP", "PR"],
    "RJ-MT": ["MG", "GO"],
    "RJ-PA": ["MG", "GO", "TO"],
    "RJ-PB": ["MG", "BA", "PE"],
    "RJ-PE": ["MG", "BA"],
    "RJ-PI": ["MG", "BA"],
    "RJ-PR": ["SP"],
    "RJ-RN": ["MG", "BA", "CE"],
    "RJ-RO": ["MG", "GO", "MT"],
    "RJ-RR": ["MG", "GO", "MT", "AM"],
    "RJ-RS": ["SP", "PR"],
    "RJ-SC": ["SP", "PR"],
    "RJ-SE": ["MG", "BA"],
    "RJ-SP": [],
    "RJ-TO": ["MG", "GO"],

    // --- ROTAS DO RIO GRANDE DO NORTE (RN) ---
    "RN-AC": ["PB", "PE", "BA", "GO", "MT", "RO"],
    "RN-AL": ["PB", "PE"],
    "RN-AP": ["CE", "PI", "MA", "PA"],
    "RN-AM": ["CE", "PI", "MA", "PA"],
    "RN-BA": ["PB", "PE"],
    "RN-CE": [],
    "RN-DF": ["PB", "PE", "BA", "GO"],
    "RN-ES": ["PB", "PE", "BA", "MG"],
    "RN-GO": ["PB", "PE", "BA"],
    "RN-MA": ["CE", "PI"],
    "RN-MG": ["PB", "PE", "BA"],
    "RN-MS": ["PB", "PE", "BA", "GO"],
    "RN-MT": ["PB", "PE", "BA", "GO"],
    "RN-PA": ["CE", "PI", "MA"],
    "RN-PB": [],
    "RN-PE": ["PB"],
    "RN-PI": ["CE"],
    "RN-PR": ["PB", "PE", "BA", "MG", "SP"],
    "RN-RJ": ["PB", "PE", "BA", "MG"],
    "RN-RO": ["PB", "PE", "BA", "GO", "MT"],
    "RN-RR": ["PB", "PE", "BA", "GO", "MT", "AM"],
    "RN-RS": ["PB", "PE", "BA", "MG", "SP", "PR"],
    "RN-SC": ["PB", "PE", "BA", "MG", "SP"],
    "RN-SE": ["PB", "PE", "BA"],
    "RN-SP": ["PB", "PE", "BA", "MG"],
    "RN-TO": ["PB", "PE", "BA", "GO"],

    // --- ROTAS DE RONDÔNIA (RO) ---
    "RO-AC": [],
    "RO-AL": ["MT", "GO", "BA", "SE"],
    "RO-AP": ["MT", "PA"],
    "RO-AM": [],
    "RO-BA": ["MT", "GO"],
    "RO-CE": ["MT", "GO", "TO", "PI"],
    "RO-DF": ["MT", "GO"],
    "RO-ES": ["MT", "GO", "MG"],
    "RO-GO": ["MT"],
    "RO-MA": ["MT", "TO"],
    "RO-MG": ["MT", "GO"],
    "RO-MS": ["MT"],
    "RO-MT": [],
    "RO-PA": ["MT"],
    "RO-PB": ["MT", "GO", "BA", "PE"],
    "RO-PE": ["MT", "GO", "BA"],
    "RO-PI": ["MT", "TO"],
    "RO-PR": ["MT", "MS"],
    "RO-RJ": ["MT", "GO", "MG"],
    "RO-RN": ["MT", "GO", "BA", "CE"],
    "RO-RR": ["AM"],
    "RO-RS": ["MT", "MS", "PR"],
    "RO-SC": ["MT", "MS", "PR"],
    "RO-SE": ["MT", "GO", "BA"],
    "RO-SP": ["MT", "GO", "MG"],
    "RO-TO": ["MT"],

    // --- ROTAS DE RORAIMA (RR) ---
    "RR-AC": ["AM", "RO"],
    "RR-AL": ["AM", "PA", "TO", "BA", "SE"],
    "RR-AP": ["AM", "PA"],
    "RR-AM": [],
    "RR-BA": ["AM", "MT", "GO"],
    "RR-CE": ["AM", "PA", "MA", "PI"],
    "RR-DF": ["AM", "MT", "GO"],
    "RR-ES": ["AM", "MT", "GO", "MG"],
    "RR-GO": ["AM", "MT"],
    "RR-MA": ["AM", "PA"],
    "RR-MG": ["AM", "MT", "GO"],
    "RR-MS": ["AM", "MT"],
    "RR-MT": ["AM"],
    "RR-PA": ["AM"],
    "RR-PB": ["AM", "PA", "MA", "PI", "CE"],
    "RR-PE": ["AM", "PA", "MA", "PI", "CE"],
    "RR-PI": ["AM", "PA", "MA"],
    "RR-PR": ["AM", "MT", "MS"],
    "RR-RJ": ["AM", "MT", "GO", "MG"],
    "RR-RN": ["AM", "PA", "MA", "PI", "CE"],
    "RR-RO": ["AM"],
    "RR-RS": ["AM", "MT", "MS", "PR"],
    "RR-SC": ["AM", "MT", "MS", "PR"],
    "RR-SE": ["AM", "MT", "GO", "BA"],
    "RR-SP": ["AM", "MT", "GO", "MG"],
    "RR-TO": ["AM", "PA"],

    // --- ROTAS DO RIO GRANDE DO SUL (RS) ---
    "RS-AC": ["SC", "PR", "MS", "MT", "RO"],
    "RS-AL": ["SC", "PR", "SP", "MG", "BA", "SE"],
    "RS-AP": ["SC", "PR", "SP", "MG", "GO", "TO", "PA"],
    "RS-AM": ["SC", "PR", "MS", "MT"],
    "RS-BA": ["SC", "PR", "SP", "MG"],
    "RS-CE": ["SC", "PR", "SP", "MG", "BA", "PI"],
    "RS-DF": ["SC", "PR", "MS", "GO"],
    "RS-ES": ["SC", "PR", "SP", "MG"],
    "RS-GO": ["SC", "PR", "MS"],
    "RS-MA": ["SC", "PR", "MS", "TO"],
    "RS-MG": ["SC", "PR", "SP"],
    "RS-MS": ["SC", "PR"],
    "RS-MT": ["SC", "PR", "MS"],
    "RS-PA": ["SC", "PR", "MS", "TO"],
    "RS-PB": ["SC", "PR", "SP", "MG", "BA", "PE"],
    "RS-PE": ["SC", "PR", "SP", "MG", "BA"],
    "RS-PI": ["SC", "PR", "SP", "MG", "BA"],
    "RS-PR": ["SC"],
    "RS-RJ": ["SC", "PR", "SP"],
    "RS-RN": ["SC", "PR", "SP", "MG", "BA", "CE"],
    "RS-RO": ["SC", "PR", "MS", "MT"],
    "RS-RR": ["SC", "PR", "MS", "MT", "AM"],
    "RS-SC": [],
    "RS-SE": ["SC", "PR", "SP", "MG", "BA"],
    "RS-SP": ["SC", "PR"],
    "RS-TO": ["SC", "PR", "MS", "MT"],

    // --- ROTAS DE SANTA CATARINA (SC) ---
    "SC-AC": ["PR", "MS", "MT", "RO"],
    "SC-AL": ["PR", "SP", "MG", "BA", "SE"],
    "SC-AP": ["PR", "SP", "MG", "GO", "TO", "PA"],
    "SC-AM": ["PR", "MS", "MT"],
    "SC-BA": ["PR", "SP", "MG"],
    "SC-CE": ["PR", "SP", "MG", "BA", "PI"],
    "SC-DF": ["PR", "MS", "GO"],
    "SC-ES": ["PR", "SP", "MG"],
    "SC-GO": ["PR", "MS"],
    "SC-MA": ["PR", "MS", "TO"],
    "SC-MG": ["PR", "SP"],
    "SC-MS": ["PR"],
    "SC-MT": ["PR", "MS"],
    "SC-PA": ["PR", "MS", "TO"],
    "SC-PB": ["PR", "SP", "MG", "BA", "PE"],
    "SC-PE": ["PR", "SP", "MG", "BA"],
    "SC-PI": ["PR", "SP", "MG", "BA"],
    "SC-PR": [],
    "SC-RJ": ["PR", "SP"],
    "SC-RN": ["PR", "SP", "MG", "BA", "CE"],
    "SC-RO": ["PR", "MS", "MT"],
    "SC-RR": ["PR", "MS", "MT", "AM"],
    "SC-RS": [],
    "SC-SE": ["PR", "SP", "MG", "BA"],
    "SC-SP": ["PR"],
    "SC-TO": ["PR", "MS", "MT"],

    // --- ROTAS DE SERGIPE (SE) ---
    "SE-AC": ["BA", "GO", "MT", "RO"],
    "SE-AL": [],
    "SE-AP": ["BA", "TO", "PA"],
    "SE-AM": ["BA", "GO", "MT"],
    "SE-BA": [],
    "SE-CE": ["BA", "PI"],
    "SE-DF": ["BA", "GO"],
    "SE-ES": ["BA", "MG"],
    "SE-GO": ["BA"],
    "SE-MA": ["BA", "TO"],
    "SE-MG": ["BA"],
    "SE-MS": ["BA", "GO"],
    "SE-MT": ["BA", "GO"],
    "SE-PA": ["BA", "TO"],
    "SE-PB": ["BA", "PE"],
    "SE-PE": ["AL"],
    "SE-PI": ["BA"],
    "SE-PR": ["BA", "MG", "SP"],
    "SE-RJ": ["BA", "MG"],
    "SE-RN": ["BA", "CE"],
    "SE-RO": ["BA", "GO", "MT"],
    "SE-RR": ["BA", "GO", "MT", "AM"],
    "SE-RS": ["BA", "MG", "SP", "PR"],
    "SE-SC": ["BA", "MG", "SP", "PR"],
    "SE-SP": ["BA", "MG"],
    "SE-TO": ["BA", "GO"],

    // --- ROTAS DE SÃO PAULO (SP) ---
    "SP-AC": ["MG", "GO", "MT", "RO"],
    "SP-AL": ["MG", "BA", "SE"],
    "SP-AP": ["MG", "GO", "TO", "PA"],
    "SP-AM": ["MG", "GO", "MT"],
    "SP-BA": ["MG"],
    "SP-CE": ["MG", "BA", "PI"],
    "SP-DF": ["MG", "GO"],
    "SP-ES": ["MG"],
    "SP-GO": ["MG"],
    "SP-MA": ["MG", "GO", "TO"],
    "SP-MG": [],
    "SP-MS": ["PR"],
    "SP-MT": ["MG", "GO"],
    "SP-PA": ["MG", "GO", "TO"],
    "SP-PB": ["MG", "BA", "PE"],
    "SP-PE": ["MG", "BA"],
    "SP-PI": ["MG", "BA"],
    "SP-PR": [],
    "SP-RJ": [],
    "SP-RN": ["MG", "BA", "CE"],
    "SP-RO": ["MG", "GO", "MT"],
    "SP-RR": ["MG", "GO", "MT", "AM"],
    "SP-RS": ["PR"],
    "SP-SC": ["PR"],
    "SP-SE": ["MG", "BA"],
    "SP-TO": ["MG", "GO"],

    // --- ROTAS DE TOCANTINS (TO) ---
    "TO-AC": ["MT", "RO"],
    "TO-AL": ["BA", "SE"],
    "TO-AP": ["PA"],
    "TO-AM": ["PA"],
    "TO-BA": ["GO"],
    "TO-CE": ["MA", "PI"],
    "TO-DF": ["GO"],
    "TO-ES": ["GO", "MG"],
    "TO-GO": [],
    "TO-MA": [],
    "TO-MG": ["GO"],
    "TO-MS": ["MT"],
    "TO-MT": [],
    "TO-PA": [],
    "TO-PB": ["MA", "PI", "CE"],
    "TO-PE": ["MA", "PI", "CE"],
    "TO-PI": ["MA"],
    "TO-PR": ["MT", "MS"],
    "TO-RJ": ["GO", "MG"],
    "TO-RN": ["MA", "PI", "CE"],
    "TO-RO": ["MT"],
    "TO-RR": ["PA", "AM"],
    "TO-RS": ["MT", "MS", "PR"],
    "TO-SC": ["MT", "MS", "PR"],
    "TO-SE": ["BA"],
    "TO-SP": ["GO", "MG"],
};